import * as openpgp from "openpgp";

const encryptContent = async (content: string, keys: openpgp.key.KeyResult) => {
  const { message } = await openpgp.encrypt({
    message: openpgp.message.fromText(content),
    publicKeys: [keys?.keys[0]],
    armor: false,
  });

  return await new Uint8Array(message.packets.write());
};

export default encryptContent;
